import * as React from "react";
const SvgB1Robot20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 19,
        fill: "black",
        viewBox: "0 0 20 19"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18.78 0H1.22L0 4.877V14.5h.006A3.5 3.5 0 0 0 4.669 18h10.662a3.5 3.5 0 0 0 4.663-3.5H20V4.877L18.78 0ZM18 11.537V6H2v5.537A3.5 3.5 0 0 1 6.75 16h6.5A3.5 3.5 0 0 1 18 11.537ZM17.72 4l-.5-2H2.78l-.5 2h15.44ZM3.5 13.2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM15 14.7a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgB1Robot20Px;
